<!-- Image containers -->
<div class="flex flex-wrap justify-center">
  <div class="mt-4 md:mx-4 w-full md:w-auto rounded-full" *ngFor="let image of images.controls; index as i">
    <div class="saved-images">
      <div class="saved-images--title" (click)="toggleImageDetails(i)" data-cy="toggle-image">
        {{ ("modules.evcQuote.steps.technicalDetails.steps.trajectory.photo" | translate) + " " + (i + 1) }}
        <div
          class="arrow"
          [ngClass]="{ arrow__up: !imageDetailsVisible[i], arrow__down: imageDetailsVisible[i] }"
          data-cy="image-arrow"
        ></div>
      </div>
      <div *ngIf="imageDetailsVisible[i]" class="saved-images--content" data-cy="image">
        <img [src]="baseUrl + image.value" [alt]="" />
      </div>
    </div>
    <button
      *ngIf="imageDetailsVisible[i]"
      class="btn-secondary block bottom-8 w-full mx-auto mt-8"
      (click)="remove(i)"
      data-cy="remove-image"
    >
      {{ "modules.evcQuote.steps.carDetails.fields.summary.savedCar.delete" | translate }}
    </button>
  </div>

  <label class="w-full md:w-auto text-center btn-primary mt-16 sm:mt-0 sm:self-center" *ngIf="addNewButtonVisible()">
    <span>{{
      "modules.evcQuote.steps.technicalDetails.steps.trajectory.imageTake.image" + (images.controls.length + 1)
        | translate
    }}</span>
    <input class="hidden" type="file" capture accept="image/*" (change)="sendImage($event)" data-cy="upload-image" />
  </label>

  <label class="w-full md:w-auto text-center btn-secondary my-8 sm:self-center" *ngIf="addNewButtonVisible()">
    <span>{{
      "modules.evcQuote.steps.technicalDetails.steps.trajectory.imageSelect.image" + (images.controls.length + 1)
        | translate
    }}</span>
    <input class="hidden" type="file" accept=".png, .jpg, .jpeg" (change)="sendImage($event)" data-cy="upload-image" />
  </label>
</div>
